import { motion } from 'motion/react'

export default function GiftLoader() {
  return (
    <div className="flex flex-col items-center gap-6">
      <motion.div
        className="relative"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        {/* Gift box body */}
        <motion.div
          className="relative h-16 w-16 rounded-b-lg bg-neutral-900"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
        >
          {/* Vertical ribbon */}
          <div className="absolute left-1/2 top-0 h-full w-2.5 -translate-x-1/2 bg-pink-400" />
          {/* Horizontal ribbon */}
          <div className="absolute left-0 top-1/2 h-2.5 w-full -translate-y-1/2 bg-pink-400" />
        </motion.div>

        {/* Gift box lid */}
        <motion.div
          className="absolute -top-2 left-1/2 h-3 w-[72px] -translate-x-1/2 rounded-md bg-neutral-800"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
        />

        {/* Bow */}
        <motion.div
          className="absolute -top-7 left-1/2 -translate-x-1/2"
          animate={{ y: [0, -6, 0] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: 'easeInOut' }}
        >
          <div className="relative flex items-center gap-0.5">
            <div className="h-5 w-5 rounded-full border-2 border-pink-400 bg-pink-300/30" />
            <div className="h-5 w-5 rounded-full border-2 border-pink-400 bg-pink-300/30" />
            <div className="absolute left-1/2 top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-pink-400" />
          </div>
        </motion.div>
      </motion.div>

      {/* Loading dots */}
      <div className="flex items-center gap-1.5">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="h-1.5 w-1.5 rounded-full bg-neutral-400"
            animate={{ opacity: [0.3, 1, 0.3] }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.2,
            }}
          />
        ))}
      </div>
    </div>
  )
}
